// The Sentinel mark: the agent's logo. It is the Sentinel chat item's icon in the sidebar (owner, 2026-10-21);
// the sidebar header shows the signed-in organisation instead.
import { Zap } from 'lucide-react'
import { cn } from '@/lib/utils'

export function SentinelMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-flex items-center justify-center rounded-md bg-primary', className)}
    >
      <Zap className="h-3.5 w-3.5 text-primary-foreground" />
    </span>
  )
}
